import produce from 'immer';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, IConsultarRelatorioMensalDareState } from './types';

export const INITIAL_STATE: IConsultarRelatorioMensalDareState = {
	status: 0,
	data: null,
	totalRegistrosConsulta: 0,
	previousRequest: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): IConsultarRelatorioMensalDareState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_RELATORIO_MENSAL_DARE_REQUEST: {
				draft.status = 100;
				draft.previousRequest = action.payload;
				break;
			}
			case Types.CONSULTAR_RELATORIO_MENSAL_DARE_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				draft.totalRegistrosConsulta =
					action.payload.headers['x-num-registros'];
				break;
			}

			case Types.CONSULTAR_RELATORIO_MENSAL_DARE_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CONSULTAR_RELATORIO_MENSAL_DARE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.previousRequest = INITIAL_STATE.previousRequest;
				draft.totalRegistrosConsulta = INITIAL_STATE.totalRegistrosConsulta;
				break;
			}

			default:
		}
		return draft;
	});
}
